module.exports = __webpack_public_path__ + "img/count-symbol-one.3a81a2aa.png";